package com.tregz.tremenz.ui.display

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.w3c.dom.events.EventListener

/** Backed by a resize listener, so a rotated tablet or a dragged window re-lays out. */
@Composable
actual fun isLandscape(): Boolean {
    var landscape by remember { mutableStateOf(window.innerWidth > window.innerHeight) }
    DisposableEffect(Unit) {
        val onResize = EventListener { landscape = window.innerWidth > window.innerHeight }
        window.addEventListener("resize", onResize)
        onDispose { window.removeEventListener("resize", onResize) }
    }
    return landscape
}
